import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('alb_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    if (localStorage.getItem('alb_safe_mode') === '1') config.headers['X-Safe-Mode'] = '1';
    return config;
});

api.interceptors.response.use((r) => r, (err) => {
    return Promise.reject(err);
});

export function fileUrl(relPath) {
    if (!relPath) return null;
    if (relPath.startsWith('http')) return relPath;
    const base = relPath.startsWith('/api/')
        ? `${BACKEND_URL}${relPath}`
        : `${API_BASE}${relPath.startsWith('/') ? '' : '/'}${relPath}`;
    const token = localStorage.getItem('alb_token');
    if (!token || !relPath.includes('/files/')) return base;
    return `${base}${base.includes('?') ? '&' : '?'}token=${encodeURIComponent(token)}`;
}

export function formatViews(n) {
    if (n == null) return '0';
    if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
    if (n >= 1_000) return `${(n / 1_000).toFixed(1)}K`;
    return String(n);
}

export function timeAgoCa(iso) {
    if (!iso) return '';
    const then = new Date(iso).getTime();
    const diff = Math.max(0, (Date.now() - then) / 1000);
    if (diff < 60) return 'fa uns segons';
    if (diff < 3600) return `fa ${Math.floor(diff / 60)} min`;
    if (diff < 86400) return `fa ${Math.floor(diff / 3600)} h`;
    if (diff < 86400 * 7) return `fa ${Math.floor(diff / 86400)} d`;
    if (diff < 86400 * 30) return `fa ${Math.floor(diff / 86400 / 7)} setm`;
    if (diff < 86400 * 365) return `fa ${Math.floor(diff / 86400 / 30)} mes`;
    return `fa ${Math.floor(diff / 86400 / 365)} any`;
}
